module.exports = __webpack_public_path__ + "static/media/menu.1a4da656.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/components/header/assets/menu.png
 ** module id = 555
 ** module chunks = 0
 **/